import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class UserShipDetails extends Mixins(CommonView) {
    // kurukuru: boolean = false;
    // pnkzList: {name: string, path: string | null}[] = [{name: "TOP", path: "/"}, {name: "マイページ", path: "/mypage"}, {name: "配送履歴", path: "/mypage/userShip"}, {name: "配送履歴詳細", path: null}];
    // public error: string = "";

    // public userShip: BASEAPI.UserShip | null = null;
    // public userPrizeList: BASEAPI.UserPrize[] = [];
    // public prizeList: {src: string, title: string}[] = [];
    // public visible: boolean = false;
    // public i: number | null = null;

    // public async created() {
    //     if (await this.isLoginRedirect(true)) return;
        
    //     await this.init();

    // }

    // @Watch('$route')
    // public async init() {
    //     if (await this.isLoginRedirect(true)) return;

    //     this.kurukuru = true;

    //     let userShipId = Number(this.$route.params.no);
    //     if(!userShipId) {
    //         this.$router.push("/");
    //         return;
    //     }

    //     let res = await BASEAPI.UserShipController.getUserShipUsingGET(userShipId).catch(AxiosErrorHandler);
    //     if (isAxiosError(res)) {
    //         this.error = "" + res.data;
    //         return;
    //     }
    //     this.userShip = res.data;

    //     let resPrize = await BASEAPI.OrderHistoryPrizeController.getUserPrizeUsingGET(undefined, undefined, undefined, userShipId).catch(AxiosErrorHandler);
    //     if (isAxiosError(resPrize)) {
    //         this.error = "" + resPrize.data;
    //         return;
    //     }
    //     this.userPrizeList = resPrize.data;
    //     this.userPrizeList?.forEach(prize => {
    //         this.prizeList.push({src: prize.image!, title: prize.title!});
    //     });

    //     this.kurukuru = false;
    // }

    // showImg (index: number) {
    //     this.i = index;
    //     this.visible = true;
    // }
    // handleHide () {
    //     this.visible = false;
    // }
}
